@import ../../../styles/helpers
.container
    display: flex
    padding: 13px
    padding-left: 20px
    position: absolute
    top: 0
    left: -16px
    z-index: 10
    width: 100%
    box-sizing: content-box
    justify-content: space-between
    background: rgba(25, 26, 35, 0.8)
    -webkit-backdrop-filter: blur(20px)
    backdrop-filter: blur(20px)
    &.group
        background-color: $page_background
    +m
        &:not(.group)
            padding: 13px
            padding-right: 20px
            background: rgba(25, 26, 35, 0.8)
            border-bottom: 1px solid $bordercolor
        
    &__left
        display: flex
        gap: $external_margin
        width: 100%
        justify-content: space-between
        +body

        +m
            gap: 5px
            padding: 0px 8px

        &__avatar
            width: 66px
            height: 66px
            img
                width: 66px
                height: 66px
                margin-right: 16px
                border-radius: 100px

        &__info
            padding-left: 25px
            display: flex
            flex-direction: column
            justify-content: space-between

            &__name
                font-size: 25px
                line-height: 29px
                font-weight: semi-bold

            &__state
                display: flex
                align-items: center

                &__icon
                    bottom: 2px
                    right: 2px
                    display: flex
                    align-items: center
                    justify-content: left
                    gap: 0px
                    max-width: 70px
                    height: 28px
                    border-radius: 50%

                    img
                        width: 28px
                        height: 28px
                        margin-right: -10px
                        border-radius: 100px

                &__stringActive
                    margin-left: 20px
                    font-size: 16px
                    line-height: 19px

    &__right
        display: none
        justify-content: center
        align-items: center
        gap: 36px

        +m
            display: flex
            gap: 5px

        button
            color: #ffffff
            opacity: 0.4
            width: 28px
            height: 28px

.topGradient
    background: linear-gradient(0, #11141B 5.76%, rgba(17, 20, 27, 0.8) 41.96%, rgba(17, 20, 27, 0.56311) 67.2%, rgba(17, 20, 27, 0) 97.72%)
    transform: rotate(180deg)
    width: -webkit-fill-available
    height: 100px
    position: absolute
    bottom: -120px

.setting
    background: #1B2028
    z-index: 10
    height: 100vh
    padding: 0px

.avatar
    height: $icon_size
    position: relative
    display: flex
    justify-content: left
    align-items: center
    img
        height: 100%
        border-radius: 100px
    span
        margin-left: $context_margin
    +m
        height: $icon_size_m
        flex-grow: 1

.active
    position: absolute
    bottom: 2px
    right: 2px
    display: flex
    align-items: center
    justify-content: center
    width: 12px
    height: 12px
    border-radius: 50%
    border: 1px solid $neutrals8
    background-color: $pink

.backButton
    display: none
    width: 30px
    flex-grow: 0 !important
    background-color: transparent !important
    svg
        margin: 0 !important
        fill: white
    +m
        display: block

.chatAction
    display: block !important
    margin-right: 15px !important
    +m
        display: block !important
        margin-right: 0px !important
    svg
        fill: white
        width: 30px
        height: 30px
